import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editResourceDetailsConfiguration(
    req: Boundaries["editResourceDetailsConfiguration"]["request"],
  ): void;
}

function useEditResourceDetailsConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditResourceDetailsConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditResourceDetailsConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditResourceDetailsConfigurationRequestFailure(planzone),
    ),
    editResourceDetailsConfiguration: core.editResourceDetailsConfiguration,
  };
}

export { useEditResourceDetailsConfiguration };
